import React from 'react';

import { useFormikContext } from 'formik';

import Input from 'components/shared/Input/Input';
import Switch from 'components/shared/Switch/Switch';
import Divider from 'components/shared/Divider/Divider';
import Allowed from 'components/shared/Permissions/Allowed';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import SectionList from 'components/practice/UserPreferences/components/SectionList';

import TipSettings from './TipSettings';
import TechnologyFeeSettings from './TechnologyFeeSettings';

const OperationalSettings = ({ setShowTechnologyModal }) => {
  const { setFieldValue, values } = useFormikContext();

  const handleStickyNotesChange = (checked) => {
    setFieldValue('displaySettings', {
      ...values?.displaySettings,
      sticky_notes: { alert: checked }
    });
    setFieldValue('stickyNotesAlert', checked);
  };

  const handleRequireInvoiceReviewChange = (checked) => {
    setFieldValue('displaySettings', {
      ...values?.displaySettings,
      require_invoice_review: checked
    });
    setFieldValue('requireInvoiceReview', checked);
  };

  return (
    <>
      <SectionList
        title="Operational settings"
        description="Configure practice-specific options like technology fee, sticky notes, and batch time preferences.">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2">
            <Switch
              checked={values?.stickyNotesAlert}
              onChange={handleStickyNotesChange}
              id="sticky-notes-switch"
            />
            <label htmlFor="sticky-notes-switch" className="text-sm font-400 text-neutral-900">
              Automatically open sticky notes
            </label>
          </div>

          <Allowed requiredModules="medipay.technology_fee">
            <Divider />

            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <Switch
                  checked={values?.requireInvoiceReview}
                  onChange={handleRequireInvoiceReviewChange}
                  id="require-invoice-review-switch"
                />
                <label
                  htmlFor="require-invoice-review-switch"
                  className="text-sm font-400 text-neutral-900">
                  Require invoice review
                </label>
              </div>
              <p className="ml-[52px] text-xs font-400 text-neutral-600">
                When enabled, an invoice sent to a kiosk shows the invoice for the patient to review
                first — they tap to start the card payment. When disabled, the kiosk prompts for
                card payment immediately on landing.
              </p>
            </div>
          </Allowed>

          <Allowed requiredModules="medipay.technology_fee">
            <Divider />
            <TechnologyFeeSettings setShowTechnologyModal={setShowTechnologyModal} />
          </Allowed>

          <Allowed requiredModules="medipay.payment_suite">
            <Divider />
            <TipSettings />
          </Allowed>
        </div>
      </SectionList>

      <Divider />

      <SectionList
        title="Payment batch time"
        description="Daily cutoff for batching and transferring processed payments to your bank.">
        <div className="flex flex-col gap-2">
          <label className="text-sm font-500 text-neutral-800">Transaction batch time</label>
          {/* Read only for now */}
          <Input value="07:00 AM, EST" disabled className="w-max" icon="clock-mono" />
        </div>
      </SectionList>
    </>
  );
};

export default withErrorBoundary(OperationalSettings);
